import React from "react";
import { Button } from "@material-ui/core";
import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { useDispatch } from "react-redux";
import { base_url  , postHeader} from "../Helpers/request";
import { cartlengthvalue } from "../Reducer/cartReducer";
import { Modal } from "react-bootstrap";
import Loader from "./Loader"
import swal from "sweetalert";

const styles = {
  body: {
    fontFamily: "Roboto, Open Sans, sans-serif",
    fontSize: "16px",
  },
  input: {
    fontSize: "13px",
    border: "1px solid #aaa",
    height: "50px",
    borderRadius: "10px",
    padding: "8px",
  },
  img: {
    right: "10px !important",
    top: "10px !important",
  },
};


const Clover = ({data , popupclose}) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [loader  , setLoader] = useState(false)
  const [card, setCard] = useState({
    number: "4005562231212123",
    brand: "VISA",
    cvv: "123",
    exp_month: "05",
    exp_year: "2023",
  });

  const elements = window.clover.elements();
  const cardNumber = elements.create("CARD_NUMBER", styles);
  const cardDate = elements.create("CARD_DATE", styles);
  const cardCvv = elements.create("CARD_CVV", styles);
  const cardPostalCode = elements.create("CARD_POSTAL_CODE", styles);

  useEffect(() => {
    const displayError = document.getElementById("card-errors");
    cardNumber.mount("#card-number");
    cardDate.mount("#card-date");
    cardCvv.mount("#card-cvv");
    cardPostalCode.mount("#card-postal-code");

    cardNumber.addEventListener("change", (event) => {
      displayError.textContent = event.error ? event.error.message : "";
    });
    cardDate.addEventListener("change", (event) => {
      displayError.textContent = event.error ? event.error.message : "";
    });
    cardCvv.addEventListener("change", (event) => {
      displayError.textContent = event.error ? event.error.message : "";
    });
    cardPostalCode.addEventListener("change", (event) => {
      displayError.textContent = event.error ? event.error.message : "";
    });
    const cloverFooter = document.getElementsByClassName("clover-footer")[0];
    if (cloverFooter) {
      cloverFooter.style.display = "none";
    }

    return () => {
      const cloverFooter = document.getElementsByClassName("clover-footer")[0];
      cloverFooter && cloverFooter.parentNode.removeChild(cloverFooter);
    };
  }, []);

  const createCharge = async (response) => {
    setLoader(true)
    const source = response.token;
    const mydata = {
      clover_token : source,
      order_id : data?.order_id
    };
    const chargeResponse = await axios.post(base_url + "/order/cloverpayment", mydata , {
      headers : postHeader
    });
    if(chargeResponse.data.status === 1){
      setLoader(false)
      dispatch(cartlengthvalue(0));
      sessionStorage.removeItem("bw-checkoutdata");
      history.push(
        `/ordersuccess/${chargeResponse.data.data.order_id}/${chargeResponse.data.data.order_no}/${chargeResponse.data.data.txn_id}`
      );
    }else{
     setLoader(false)
     swal(chargeResponse.data.message)
    }
  }

  const handleFormSubmit =  (e) => {
    e.preventDefault();
    const displayError = document.getElementById("card-errors");
    window.clover
      .createToken()
      .then((result) => {
        if (result.errors) {
          Object.values(result.errors).forEach(function (value) {
            displayError.textContent = value;
          });
        }
        return result;
      })
      .then((resp) => createCharge(resp))
      .catch((err) => console.log(err));
       setCard("")
  };

  return (
    <>
     <div className="App" id="iframeapp">
      <div id="card-errors" role="alert" />
      <div className="text-left mt-16 pb-5">
        <form id="payment-form" noValidate autoComplete="off">
          <fieldset className="FormGroup">
            <div className="FormRow">
              <div id="card-number" className="field card-number" />
            </div>
            <div className="FormRow">
              <div id="card-date" className="field third-width" />
              <div id="card-cvv" className="field third-width" />
              <div id="card-postal-code" className="field third-width" />
            </div>
          </fieldset>
        </form>
        <Button aria-label="Pay"
          variant="contained"
          color="primary"
          size="large"
          onClick={handleFormSubmit}
        >
          Pay 
        </Button>
      </div>
    </div>
    <Modal show = {loader}>
      <Loader/>
    </Modal>
    </>
  );
};

export default Clover;
